export default __webpack_public_path__ + "static/media/img-2.5ba985f3.svg";